export default defineNuxtRouteMiddleware(async (to) => {
	// Check if this is an admin route:
	// - /admin routes (global admin, except login)
	// - /:tenant/admin routes (tenant admin)
	const isGlobalAdmin = to.path.startsWith('/admin') && to.path !== '/admin/login';
	const isTenantAdmin = /^\/[^/]+\/admin(\/|$)/.test(to.path);
	
	if (!isGlobalAdmin && !isTenantAdmin) {
		return;
	}

	// Dynamically import to avoid bundling Firebase globally
	const { getCurrentUser } = await import('~/composables/useAdminAuth');

	// Wait for Firebase Auth to initialize and get current user
	const user = await getCurrentUser();

	// Not authenticated - redirect to login
	if (!user) {
		return navigateTo({
			path: '/admin/login',
			query: { redirect: to.fullPath },
		});
	}

	// Email whitelist is checked server-side in /server/middleware/admin-api-auth.ts
});
